<script setup>
import { onMounted } from "vue";
import useHandleTable from "./hooks/useHandleTable";
import {
  PROCESS_COMPLETE_TYPE,
  PROCESS_COMPLETE_TYPE_OBJECT,
} from "@/constants";
import adjust from "./adjust.vue";

const {
  searchRef,
  searchData,
  tableLoading,
  tableData,
  columns,
  pages,
  adjustRef,
  time,
  getList,
  handleReset,
  handleDetail,
  dateTimeChange,
} = useHandleTable();

const tag_color = {
  act_complete_type_001: "success",
  act_complete_type_002: "warning",
};

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '经办任务' }">
    <template #header-btn />
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="processDefinitionName">
          <el-input
            v-model="searchData.processDefinitionName"
            placeholder="流程名称"
          />
        </el-form-item>
        <el-form-item prop="processDefinitionKey">
          <el-input
            v-model="searchData.processDefinitionKey"
            placeholder="流程key"
          />
        </el-form-item>
        <el-form-item prop="startTime">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="To"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="YYYY/MM/DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            @change="dateTimeChange"
          />
        </el-form-item>
        <el-form-item prop="completeType">
          <el-select
            v-model="searchData.completeType"
            placeholder="流程状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in PROCESS_COMPLETE_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'completeType'"
                :type="tag_color[row[item.prop]]"
                >{{ PROCESS_COMPLETE_TYPE_OBJECT[row[item.prop]] }}</el-tag
              >
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleDetail(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>

  <adjust ref="adjustRef" />
</template>

<style scoped></style>
